import { render } from "./CompanyDetail.vue?vue&type=template&id=0aa45c6e&scoped=true&ts=true"
import script from "./CompanyDetail.vue?vue&type=script&lang=ts"
export * from "./CompanyDetail.vue?vue&type=script&lang=ts"

import "./CompanyDetail.vue?vue&type=style&index=0&id=0aa45c6e&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa45c6e"]])

export default __exports__